// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product__item__files{display:flex;flex-wrap:wrap;gap:var(--gap)}@media(max-width:576px){.product__item__files .button{--button-height:40px;--font-size:0.875rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
